export default __webpack_public_path__ + "static/data-quality-v5-0390ecc654fec20c555f210347980569.svg";